import React from "react";
import CustomerClickBoard from "./CustomerClickBoard";

const RequestDataVisualizationCustomerE = () => <CustomerClickBoard scope="employees" />;

export default RequestDataVisualizationCustomerE;
